import type { paths } from "@/api-schema";
import { CUSTOMER_SAP_EXPORT_SEARCH_RESOURCE } from "@/common/api/customer-sap-export/use-customer-sap-export-search.query";
import { VEHICLE_BUY_IN_RESOURCE } from "@/common/api/vehicle-buy-in/use-vehicle-buy-in-create-data.query";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CUSTOMER_SEARCH_RESOURCE } from "./use-customer-search.query";

export const CUSTOMER_BULK_DELETE_API_PATH = `/v1/${CUSTOMER_SEARCH_RESOURCE}/bulk-delete` as const;

export type CustomerBulkDeleteResponse =
  paths[typeof CUSTOMER_BULK_DELETE_API_PATH]["post"]["responses"][200]["content"]["application/json"];
export type CustomerBulkDeleteBody =
  paths[typeof CUSTOMER_BULK_DELETE_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export const useCustomerBulkDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CustomerBulkDeleteResponse, Error, CustomerBulkDeleteBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.post<CustomerBulkDeleteResponse>(CUSTOMER_BULK_DELETE_API_PATH, body);
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all(
        [CUSTOMER_SEARCH_RESOURCE, CUSTOMER_SAP_EXPORT_SEARCH_RESOURCE, VEHICLE_BUY_IN_RESOURCE].map((resource) =>
          queryClient.invalidateQueries({ queryKey: [resource] }),
        ),
      );
    },
  });
};
